__turbopack_context__.v({
  "className": "ovR8Ma_className",
  "variable": "ovR8Ma_variable",
});
